"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.71165 0.250795C6.11721 0.738662 4.06937 2.92938 3.60894 4.63959C2.80788 7.61431 3.9981 10.7409 6.53113 12.3156C8.42906 13.4955 11.6969 13.4473 13.5637 12.2119C15.6524 10.8296 16.5083 9.19402 16.5083 6.5847C16.5083 4.00884 15.654 2.34079 13.6591 1.02074C12.2239 0.0707725 9.46603 -0.28626 7.71165 0.250795ZM17.2103 14.4214C16.6315 15.8067 15.6333 16.3963 14.1583 16.2243C13.2368 16.1165 12.9644 16.2494 12.502 17.0324C11.977 17.9214 11.9837 18.0141 12.6392 18.8473C13.0186 19.3298 13.3295 20.1359 13.3295 20.6385C13.3295 21.1411 13.0186 21.9472 12.6392 22.4297C11.9837 23.2629 11.977 23.3556 12.502 24.2446C12.9644 25.0276 13.2368 25.1605 14.1583 25.0527C15.6333 24.8807 16.6315 25.4703 17.2103 26.8556C17.6025 27.7945 17.8672 28 18.6833 28C19.4994 28 19.7641 27.7945 20.1563 26.8556C20.7352 25.4703 21.7333 24.8807 23.2083 25.0527C24.1298 25.1605 24.4022 25.0276 24.8646 24.2446C25.3896 23.3556 25.3829 23.2629 24.7274 22.4297C23.8477 21.3114 23.8477 19.9656 24.7274 18.8473C25.3829 18.0141 25.3896 17.9214 24.8646 17.0324C24.4022 16.2494 24.1298 16.1165 23.2083 16.2243C21.7333 16.3963 20.7352 15.8067 20.1563 14.4214C19.7641 13.4824 19.4994 13.277 18.6833 13.277C17.8672 13.277 17.6025 13.4824 17.2103 14.4214ZM0.882844 16.9721C0.801825 17.0462 -0.12334 18.1362 0.0138514 19.7923C0.192535 21.9465 1.28237 23.5637 3.38609 24.7964C5.18899 25.8528 8.29388 26.6615 10.5455 26.6615H12.3056L11.4794 25.4446C9.86054 23.0588 9.56507 19.384 10.8005 16.9955L11.3389 15.9539H6.62014H1.90108C1.90108 15.9539 0.963863 16.898 0.882844 16.9721ZM20.0218 19.3C20.3898 19.6681 20.691 20.2704 20.691 20.6385C20.691 21.0066 20.3898 21.6089 20.0218 21.9769C19.6537 22.345 19.0514 22.6462 18.6833 22.6462C18.3152 22.6462 17.7129 22.345 17.3448 21.9769C16.9768 21.6089 16.6756 21.0066 16.6756 20.6385C16.6756 20.2704 16.9768 19.6681 17.3448 19.3C17.7129 18.932 18.3152 18.6308 18.6833 18.6308C19.0514 18.6308 19.6537 18.932 20.0218 19.3Z",
    fill: fill
  }));
};

exports["default"] = _default;